import React, { useRef } from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";

import { notifError } from "../../actions/FlashMessageActions";
import OfferAPI from "../../api/OfferAPI";
import "../../css/admin/smartlist.scss";
import history from "../common/navigation/AppHistory";
import { PROJECTS_ROUTE } from "../routes/routes";
import CircularSpinner from "../utils/loaderEditor/CircularSpinner";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function AdvertisingsCreate(): JSX.Element {
  const { t } = useTranslation("editor-advertisings");
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state: AppState) => state.languages.current,
  );
  const { type, projectSlug } = useParams<{
    type: string;
    projectSlug: string;
  }>();

  const getAdvertisingListQueryKey = OfferAPI.generateQuery({
    fn: OfferAPI.getAdvertisingList,
    params: [
      {
        projectSlug,
      },
    ],
  }).queryKey;

  const createAdvertising = useMutation({
    mutationFn: async () =>
      OfferAPI.createAdvertising({
        type,
        languageId: currentLanguage.uuid,
        projectSlug,
      }),
    onSuccess: ({ uuid }: { uuid: string }) => {
      queryClient.invalidateQueries(getAdvertisingListQueryKey);
      history.replace(
        `${PROJECTS_ROUTE}/${projectSlug}/advertisings/edit/${uuid}`,
      );
    },
    onError: () => {
      dispatch(notifError(t("createError")));
      history.replace(`${PROJECTS_ROUTE}/${projectSlug}/advertisings/`);
    },
  });

  const hasCreatedRef = useRef(false);

  useMount(() => {
    if (!hasCreatedRef.current) {
      hasCreatedRef.current = true;
      createAdvertising.mutate();
    }
  });

  return (
    <div className="campaign-form-container">
      <CircularSpinner loading />
    </div>
  );
}

export default AdvertisingsCreate;
